import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Layout } from '../../../../components/Header/components/Layout.js';
export const Content = /*#__PURE__*/_styled(Layout, process.env.NODE_ENV === "production" ? {
  target: "ezsenm80"
} : {
  target: "ezsenm80",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "r4f2yk",
  styles: "display:flex;justify-content:right"
} : {
  name: "r4f2yk",
  styles: "display:flex;justify-content:right/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXNDIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBMYXlvdXQgfSBmcm9tICcuLi8uLi8uLi8uLi9jb21wb25lbnRzL0hlYWRlci9jb21wb25lbnRzL0xheW91dC5qcyc7XG5leHBvcnQgY29uc3QgQ29udGVudCA9IHN0eWxlZChMYXlvdXQpIGBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiByaWdodDtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db250ZW50LmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});